import { Track } from "@/src/lib/tracking";
import { appOspSecurity } from "@api/osp";
import { arePortfolioUploadAuthHeadersReady } from "../constants/uploadConstants";

/**
 * Modal may mount before `useRequestHeader` populates; fetch fresh credentials at upload time.
 */
export async function resolvePortfolioUploadAuthHeaders(
  authHeaders: Record<string, string>,
): Promise<Record<string, string>> {
  if (arePortfolioUploadAuthHeadersReady(authHeaders)) {
    return authHeaders;
  }

  try {
    const fresh = await appOspSecurity.getRequestHeader();
    if (arePortfolioUploadAuthHeadersReady(fresh)) {
      return fresh;
    }
  } catch (error) {
    Track.log(
      "warn",
      "PortfolioScreenshot",
      "resolve upload auth headers failed",
      { cause: String(error) },
    );
  }

  return authHeaders;
}
